module.exports = __webpack_public_path__ + "img/201805-5.5bc3d3e9.jpeg";